import React from "react";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import { ICardProps } from "./definitions";
import { Space } from "../space/Space";
import { CardInfo } from "./CardInfo";
import Divider from "@amzn/meridian/divider";

export const Card: React.FC<ICardProps> = ({ header, data, type }) => {
    return (
        <Box type={"fill"} backgroundColor={"principal"} width={"100%"} spacingInset={"400"}>
            <Text type={"h300"}>{header}</Text>
            <Space size={"xs"} />
            <CardInfo
                title={"Tax bills"}
                overdueCount={data?.TAX_BILL?.OVERDUE?.docCount}
                unreadCount={data?.TAX_BILL?.UNREAD?.docCount}
                openCount={data?.TAX_BILL?.OPEN?.docCount}
                link={
                    type === "ASSIGNED_TO_ME"
                        ? `assigned-to-me/TAX_BILL`
                        : `tax-bill-${type.toLocaleLowerCase()}`
                }
            />
            <CardInfo
                title={"Hearing notices"}
                overdueCount={data?.HEARING_NOTICE?.OVERDUE?.docCount}
                unreadCount={data?.HEARING_NOTICE?.UNREAD?.docCount}
                openCount={data?.HEARING_NOTICE?.OPEN?.docCount}
                link={
                    type === "ASSIGNED_TO_ME"
                        ? `assigned-to-me/HEARING_NOTICE`
                        : `hearing-notice-${type.toLocaleLowerCase()}`
                }
            />
            <CardInfo
                title={"Value notices"}
                overdueCount={data?.VALUE_NOTICE?.OVERDUE?.docCount}
                unreadCount={data?.VALUE_NOTICE?.UNREAD?.docCount}
                openCount={data?.VALUE_NOTICE?.OPEN?.docCount}
                link={
                    type === "ASSIGNED_TO_ME"
                        ? `assigned-to-me/VALUE_NOTICE`
                        : `value-notice-${type.toLocaleLowerCase()}`
                }
            />
            <CardInfo
                title={"Checks"}
                overdueCount={data?.CHECK?.OVERDUE?.docCount}
                unreadCount={data?.CHECK?.UNREAD?.docCount}
                openCount={data?.CHECK?.OPEN?.docCount}
                link={
                    type === "ASSIGNED_TO_ME"
                        ? `assigned-to-me/CHECK`
                        : `check-${type.toLocaleLowerCase()}`
                }
            />

            {(type === "PERSONAL" || type === "ASSIGNED_TO_ME") && (
                <CardInfo
                    title={"Tax returns"}
                    overdueCount={data?.TAX_RETURN?.OVERDUE?.docCount}
                    unreadCount={data?.TAX_RETURN?.UNREAD?.docCount}
                    openCount={data?.TAX_RETURN?.OPEN?.docCount}
                    link={
                        type === "ASSIGNED_TO_ME"
                            ? `assigned-to-me/TAX_RETURN`
                            : `tax-return-${type.toLocaleLowerCase()}`
                    }
                />
            )}

            <CardInfo
                title={"Miscellaneous"}
                overdueCount={data?.MISCELLANEOUS?.OVERDUE?.docCount}
                unreadCount={data?.MISCELLANEOUS?.UNREAD?.docCount}
                openCount={data?.MISCELLANEOUS?.OPEN?.docCount}
                link={
                    type === "ASSIGNED_TO_ME"
                        ? `assigned-to-me/MISCELLANEOUS`
                        : `miscellaneous-${type.toLocaleLowerCase()}`
                }
            />
            <Divider />
        </Box>
    );
};
